import {
  formDataRequest,
  postRequest,
} from "../libs/AxiosService.util";

export async function serviceCreateLanyardTemplate(params) {
  return await formDataRequest("lanyard/create", params);
}
export async function serviceUpdateLanyardTemplate(params) {
  return await formDataRequest("lanyard/update", params);
}
export async function serviceDeleteLanyardTemplate(params) {
  return await postRequest("lanyard/delete", params);
}
export async function serviceGetLanyardTemplateDetails(params) {
  return await postRequest("lanyard/detail", params);
}
export async function serviceGetLanyardTemplate(params) {
  return await postRequest("lanyard", params);
}

